<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {},
		data() {
			return {
			};
		},
		methods: {
		},
		mounted() {
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		max-width: 100vw;
		height: 97vh;
		margin: 0 0;
		padding: 0px;
	}
</style>
